import { render } from "./NumberLimitInput.vue?vue&type=template&id=eb89bfec&scoped=true"
import script from "./NumberLimitInput.vue?vue&type=script&lang=js"
export * from "./NumberLimitInput.vue?vue&type=script&lang=js"

import "./NumberLimitInput.vue?vue&type=style&index=0&id=eb89bfec&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb89bfec"]])

export default __exports__